<template>
  <div class="load">
    <div>
      <div>
        <div v-for="(square, index) in 9" :key="index" class="square"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted } from "vue";
import { gsap } from "gsap";
export default {
  name: "LoaderView",
  setup() {
    // GSAP animation runs after the component is mounted
    onMounted(() => {
      const squares = document.querySelectorAll(".square");

      // Create a GSAP timeline
      const tl = gsap.timeline({ repeat: -1, repeatDelay: 0.5 });

      // Animate each square with a staggered effect
      squares.forEach((square, index) => {
        tl.to(square, {
          className: "+=active", // Add the active class
          duration: 0.3,
          repeat: 1,
          yoyo: true,
          ease: "power1.inOut",
          delay: index * 0.1, // Stagger the animation for each square
        });
      });
    });
  },
};
</script>
